import React from 'react'
import Courses from '../Student/courses'
import OpenRoom from '../meeting/openRoom.js';
function Bookings() {
  return (
  <Courses openRoom ={OpenRoom}/> 
    )
}

export default Bookings